<template>
    <el-dialog :title="title" width="72%" top="0px" :visible.sync="dialogVisible" append-to-body>
        <iframe :src="url" frameborder="no" id="iframe_11" name="iframe_11" class="tab_iframe" sandbox="allow-scripts" style="width: 100%; height: 500px;">
                                                                            </iframe>
        <div slot="footer" class="dialog-footer">
            <el-button type="danger" @click="dialogVisible = false">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        getToken
    } from '@/util/auth';
    export default {
        components: {},
        data() {
            return {
                dialogVisible: false,
                dataItemTree: [],
                CustmerSchemeList: [],
                SchemeList: [],
                workflow: {},
                title: '预览当前模板',
                url: '/WorkFlowModule/WfScheme/PreviewForm?schemeId=da73c968-1937-47e0-8835-68af16bad94d'
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    
</style>